import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OrderInvoiceDetailService } from '../order-invoice-detail.service';
import { OrderInvoiceDetail } from '../order-invoice-detail';

@Component({
	selector: 'app-order-invoice-detail',
	templateUrl: './order-invoice-detail.component.html',
	styleUrls: ['./order-invoice-detail.component.css'],
	providers: [MessageService, ConfirmationService],
	standalone: false
})
export class OrderInvoiceDetailComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private orderInvoiceDetailService: OrderInvoiceDetailService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: FormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.orderInvoiceDetail = data.orderInvoiceDetail,
			this.statuses = orderInvoiceDetailService.statuses;
	}

	@Input() orderInvoiceDetail: OrderInvoiceDetail;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	orderInvoiceDetailId: number;

	// forms
	form1: FormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'orderInvoiceDetailId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'status': [],
		'orderInvoiceDetailDate': [],
		'isOrderInvoiceDetail': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole orderInvoiceDetail object
		if (this.orderInvoiceDetail) {
			this.orderInvoiceDetailId = this.orderInvoiceDetail.orderInvoiceDetailId;
			this.fixDates();
			this.form1.patchValue(this.orderInvoiceDetail);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.orderInvoiceDetailId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.orderInvoiceDetailService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderInvoiceDetail = res.data.orderInvoiceDetail;
						this.doAdd.emit(this.orderInvoiceDetail);
					},
					(err: any) => {
						console.log('orderInvoiceDetail-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('orderInvoiceDetail: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.orderInvoiceDetailService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderInvoiceDetail = res.data.orderInvoiceDetail;
						this.doUpdate.emit(this.orderInvoiceDetail);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.orderInvoiceDetailService.delete(this.orderInvoiceDetail.orderInvoiceDetailId)
				.subscribe(
					(res: any) => {
						console.log('orderInvoiceDetail-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.orderInvoiceDetail);
					},
					(err: any) => {
						console.log('orderInvoiceDetail-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			orderInvoiceDetailId: [this.orderInvoiceDetailId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
			status: [],
			orderInvoiceDetailDate: [],
			isOrderInvoiceDetail: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.orderInvoiceDetail.orderInvoiceDetailDate = moment(this.orderInvoiceDetail.orderInvoiceDetailDate).toDate();
	}
}
